import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ConsultationBanner() {
  const navigate = useNavigate();

  return (
    <Card className="bg-gradient-to-r from-grandpal-green to-grandpal-green-dark text-white mb-6">
      <CardContent className="p-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
              <MessageCircle className="h-5 w-5" />
              <h3 className="text-xl font-bold">Need Guidance?</h3>
            </div>
            <p className="text-grandpal-green-lighter mb-4">
              Chat with our free Care Advisor for instant guidance on Fair Deal applications, 
              nursing home selection, and next steps.
            </p>
            <div className="flex items-center justify-center md:justify-start gap-4 text-sm">
              <div className="flex items-center gap-1">
                <MessageCircle className="h-4 w-4" />
                <span>Free · Instant answers</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button 
              className="bg-white text-grandpal-green hover:bg-gray-50"
              onClick={() => navigate('/consultations')}
            >
              Chat with Care Advisor
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}